export default __webpack_public_path__ + "static/media/img-cube1.e53d2b29.svg";